import { Link } from 'react-router-dom';
import type { Resource } from '@/mocks/types';
import { formatCount, formatDate, getCategoryName } from '@/lib/catalog';

const BADGE_STYLES: Record<string, string> = {
  video: 'bg-primary-100 text-primary-800',
  software: 'bg-accent-100 text-accent-800',
  tutorial: 'bg-secondary-100 text-secondary-900',
};

export default function ResourceCard({ resource }: { resource: Resource }) {
  return (
    <Link
      to={`/detail/${resource.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors duration-300"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={resource.cover}
          alt={`${resource.title} - 免费91 资源封面`}
          title={`${resource.title} 免费资源`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium ${
            BADGE_STYLES[resource.category] || 'bg-background-200 text-foreground-800'
          }`}
        >
          {getCategoryName(resource.category)}
        </span>
        {resource.duration && (
          <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs">
            <i className="ri-time-line mr-1"></i>
            {resource.duration}
          </span>
        )}
      </div>

      <div className="flex flex-col flex-1 p-4">
        <h3 className="font-heading font-semibold text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {resource.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
          {resource.summary}
        </p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatCount(resource.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-heart-line"></i>
              {formatCount(resource.favorites)}
            </span>
          </span>
          <span>{formatDate(resource.publishedAt)}</span>
        </div>
      </div>
    </Link>
  );
}